document.addEventListener( 'DOMContentLoaded', handleContactUsForm );

function handleContactUsForm() {
	'use strict';

	const form = document.getElementById( 'cloudavocado-form' );

	const sendDataButton = document.querySelector(
		'[data-elem-name="buttonSubmitForm"]'
	);

	if ( ! form || ! sendDataButton ) {
		// eslint-disable-next-line no-console
		console.warn( "Contact Us Form didn't find!" );
		return;
	}

	// variable which save tag which should show error message depends on form.
	const errorMessage = document.querySelector(
		'[data-elem-name="error-message"]'
	);

	// start block of function with validation rules
	const isCorrectFullName = ( fieldData ) => {
		const fullNameRegex = /^[\p{L}'-]+(?: [\p{L}'-]+)*$/u;
		return fullNameRegex.test( fieldData.value );
	};

	const isCorrectEmail = ( fieldData ) => {
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		return emailRegex.test( fieldData.value );
	};

	const isNotEmptyField = ( fieldData ) => fieldData.value.length > 0;

	const isNotTooLongField = ( maxLength ) => ( fieldData ) =>
		fieldData.value.length <= maxLength;

	const isAcceptedRules = ( fieldData ) => fieldData.value;
	// end block of function with validation rules

	const validatedData = {
		fullName: {
			value: '',
			isValid: true,
			validationRules: {
				isCorrectFullName,
				isNotEmptyField,
				isNotTooLongField: isNotTooLongField( 254 ),
			},
		},
		email: {
			value: '',
			isValid: true,
			validationRules: {
				isCorrectEmail,
				isNotEmptyField,
				isNotTooLongField: isNotTooLongField( 254 ),
			},
		},
		message: {
			value: '',
			isValid: true,
			validationRules: {
				isNotEmptyField,
				isNotTooLongField: isNotTooLongField( 2800 ),
			},
		},
		checkboxPolicy: {
			value: false,
			isValid: true,
			isCheckbox: true,
			validationRules: {
				isAcceptedRules,
			},
		},
	};

	// func whick return string of error or success
	function getErrorMessage() {
		let amountNotValidField = 0;
		for ( const key in validatedData ) {
			if ( ! validatedData[ key ].isValid ) {
				++amountNotValidField;
			}
		}

		if ( amountNotValidField === Object.keys( validatedData ).length ) {
			return 'All fields are required.';
		}
		if (
			1 === amountNotValidField &&
			! validatedData.checkboxPolicy.isValid
		) {
			return 'The Terms of Use must be accepted.';
		}

		let amountTooLongField = 0;
		for ( const key in validatedData ) {
			const field = validatedData[ key ];
			if ( field.validationRules.isNotTooLongField ) {
				const isValidLength =
					field.validationRules.isNotTooLongField( field );
				if ( ! isValidLength ) {
					++amountTooLongField;
				}
			}
		}

		if ( amountTooLongField ) {
			return 1 === amountTooLongField
				? 'Some field is too big.'
				: 'Some fields are too big.';
		}

		return 1 === amountNotValidField
			? 'Some field is invalid.'
			: 'Some fields are invalid.';
	}

	// func which add class which make red input
	function addhighlightErrors() {
		for ( const key in validatedData ) {
			if ( ! validatedData[ key ].isValid ) {
				const inputField = document.querySelector(
					`[data-elem-name="input-${ key }"]`
				);
				if ( inputField ) {
					inputField.classList.add( 'error' );
				}
			}
		}
	}

	// func which checks if all fields is valid
	function isValidAllField() {
		for ( const key in validatedData ) {
			if ( ! validatedData[ key ].isValid ) {
				return false;
			}
		}
		return true;
	}

	// func which calls all validation func for current field
	function validatedField( fieldData ) {
		fieldData.isValid = false;
		const { validationRules } = fieldData;
		for ( const validateFn of Object.values( validationRules ) ) {
			if ( ! validateFn( fieldData ) ) {
				return;
			}
		}
		fieldData.isValid = true;
	}

	function updateFormUI() {
		if ( isValidAllField() ) {
			errorMessage.classList.remove(
				'd-inline-block',
				'icon-close-circle'
			);
			sendDataButton.disabled = false;
			return;
		}
		let isAnyInputHasError = false;
		for ( const key in validatedData ) {
			const input = form.querySelector(
				`[data-elem-name="input-${ key }"]`
			);
			if ( input && input.classList.contains( 'error' ) ) {
				sendDataButton.disabled = isAnyInputHasError = true;
				const sentenceErrorForm = getErrorMessage();
				errorMessage.textContent = sentenceErrorForm;
				errorMessage.classList.remove( 'icon-check' );
				errorMessage.classList.add(
					'icon-close-circle',
					'd-inline-block'
				);
				break;
			}
		}
		if ( ! isAnyInputHasError ) {
			errorMessage.classList.remove(
				'd-inline-block',
				'icon-close-circle'
			);
			sendDataButton.disabled = false;
		}
	}

	Object.keys( validatedData ).forEach( ( nameInputObject ) => {
		const inputField = form.querySelector(
			`[data-elem-name="input-${ nameInputObject }"]`
		);
		if ( ! inputField ) {
			return;
		}

		inputField.addEventListener( 'input', ( el ) => {
			// here trim enterence
			if ( el.target.type === 'checkbox' ) {
				validatedData[ nameInputObject ].value = el.target.checked;
			} else {
				validatedData[ nameInputObject ].value =
					inputField.value.trim();
			}
			// validate current input to understand if it's valid
			validatedField( validatedData[ nameInputObject ] );

			// toggle error class from current input depends on isValid
			inputField.classList.toggle(
				'error',
				! validatedData[ nameInputObject ].isValid
			);

			// update whole form UI
			updateFormUI();
		} );
	} );

	form.addEventListener( 'submit', startFormValidation );

	function startFormValidation( el ) {
		el.preventDefault(); // cancel rebooting page
		const allInputsData = new FormData( el.target );
		const rawdata = Object.fromEntries( allInputsData.entries() ); // here get object with sent data

		// call trim func for deleting space & validation func for every input field
		for ( const key in validatedData ) {
			if ( 'isCheckbox' in validatedData[ key ] ) {
				validatedData[ key ].value = rawdata[ key ] === 'on';
			} else {
				validatedData[ key ].value = rawdata[ key ].trim();
			}
			validatedField( validatedData[ key ] );
		}

		const fullNameParts = validatedData.fullName.value.split( /\s+/ );
		const firstName = fullNameParts[ 0 ];
		const lastName =
			fullNameParts.length > 1
				? fullNameParts.slice( 1 ).join( ' ' )
				: 'N/A';

		/* eslint-disable */
		// Prepare form data.
		const formData = {
			action: 'cloudavocado_forms_submit_contact_form',
			nonce: cloudavocado_forms.nonce,
			first_name: firstName,
			last_name: lastName,
			email: validatedData.email.value,
			message: validatedData.message.value,
		};

		if ( isValidAllField() ) {
			sendDataButton.disabled = true;
			// Check if reCAPTCHA is enabled.
			if (
				cloudavocado_forms.recaptcha_site_key &&
				typeof grecaptcha !== 'undefined'
			) {
				grecaptcha.ready( function () {
					grecaptcha
						.execute( cloudavocado_forms.recaptcha_site_key, {
							action: 'submit',
						} )
						.then( function ( token ) {
							handleSubmission( token );
						} );
				} );
			} else {
				// No reCAPTCHA, submit directly.
				handleSubmission();
			}
			return;
		}
		/* eslint-enable */

		// here will get error message if all all inputs are valid or not
		const sentenceErrorForm = getErrorMessage();
		errorMessage.textContent = sentenceErrorForm;
		sendDataButton.disabled = true;
		addhighlightErrors(); // add red border to inputs
		errorMessage.classList.add( 'icon-close-circle', 'd-inline-block' );

		function handleSubmission( recaptchaToken = '' ) {
			if ( recaptchaToken ) {
				formData.recaptcha_token = recaptchaToken;
			}
			/* eslint-disable */
			fetch( cloudavocado_forms.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: new URLSearchParams( formData ),
			} )
				.then( ( response ) => response.json() )
				.then( ( data ) => {
					if ( data.success ) {
						// Success - clear inputs and show success message.
						// start clearing all input fields after sending
						for ( const key in validatedData ) {
							const inputField = document.querySelector(
								`[data-elem-name="input-${ key }"]`
							);
							if ( inputField ) {
								if ( 'isCheckbox' in validatedData[ key ] ) {
									inputField.checked = false;
								} else {
									inputField.value = '';
								}
							}
						}
						errorMessage.textContent =
							'Your submission was successful.';
						errorMessage.classList.add(
							'icon-check',
							'd-inline-block'
						);
					} else {
						errorMessage.textContent =
							'Your submission was unsuccessful. Please try again';
						errorMessage.classList.add(
							'icon-close-circle',
							'd-inline-block'
						);
					}
				} )
				.catch( function ( error ) {
					// Handle fetch error (network issues, etc.).
					// eslint-disable-next-line no-console
					console.log( error );
				} )
				.finally( function () {
					sendDataButton.disabled = false;
				} );
			/* eslint-enable */
		}
	}
}
